const subuserStatementsDE = {
    "view": {
        "table": {
            "title": "Die Abrechnungsliste Ihres Subusers",
            "column": {
                "type": "Typ",
                "year": "Jahr",
                "month": "Monat",
                "issue_year": "Ausstellungsjahr",
                "issue_month": "Ausstellungsmonat",
                "description": "Beschreibung",
                "amount": "Betrag",
                "status": "Status",
                "details": "Einzelheiten",
                "overview": "Übersicht",
                "action": "Aktion"
            },
            "button": {
                "export_csv": "CSV exportieren",
                "download": "Herunterladen"
            },
            "placeholder": {
                "search": "Suchen..."
            },
            "label": {
                "statusOpen": "Offen",
                "statusPaid": "Bezahlt",
                "typeLicensing": "Lizenzierung",
                "typeRegular": "Regulär",
                "typeAudioMasteringServices": "Audio Mastering - Dienstleistungen",
                "typeVinylEarnings": "Vinyl-Einnahmen",
                "typeOffset": "Offset",
                "typeNotKnown": "Unbekannt",
                "monthJanuary": "Januar",
                "monthFebruary": "Februar",
                "monthMarch": "März",
                "monthApril": "April",
                "monthMay": "Mai",
                "monthJune": "Juni",
                "monthJuly": "Juli",
                "monthAugust": "August",
                "monthSeptember": "September",
                "monthOctober": "Oktober",
                "monthNovember": "November",
                "monthDecember": "Dezember"
            },
            "dropdown": {
                "markAsPaid": "Als BEZAHLT markieren",
                "markAsOpen": "Als OFFEN markieren",
                "action": "Aktion"
            },
            "message": {
                "statementUnavailable": "Alle Abrechnungen, die vor Januar 2023 ausgestellt wurden, sind als ZIP-Dateianhänge in Ihrer E-Mail verfügbar."
            }
        },
        "message": {
            "successMarkedOpen": "Die Abrechnung des Subusers wurde als OFFEN markiert!",
            "successMarkedPaid": "Die Abrechnung des Subusers wurde als BEZAHLT markiert!",
            "error": "Etwas ist schief gelaufen! Bitte aktualisieren Sie die Seite und versuchen Sie es erneut!"
        },
        "modal": {
            "markAsPaid": {
                "header": "Abrechnung als BEZAHLT markieren",
                "body": "Sind Sie sicher, dass Sie die Abrechnung {{statementName}} als BEZAHLT markieren möchten?"
            },
            "markAsOpen": {
                "header": "Abrechnung als OFFEN markieren",
                "body": "Sind Sie sicher, dass Sie die Abrechnung {{statementName}} als OFFEN markieren möchten?"
            }
        }
    },
    "viewOnly": {
        "table": {
            "title": "Ihre Abrechnungsliste",
            "column": {
                "name": "Abrechnungsname",
                "type": "Typ",
                "quarter": "Quartal",
                "year": "Jahr",
                "month": "Monat",
                "description": "Beschreibung",
                "amount": "Betrag",
                "status": "Status",
                "overview": "Übersicht",
                "details": "Einzelheiten"
            },
            "button": {
                "download": "Herunterladen",
                "export_csv": "CSV exportieren"
            },
            "placeholder": {
                "search": "Suchen..."
            },
            "label": {
                "statusOpen": "Offen",
                "statusPaid": "Bezahlt",
                "typeLicensing": "Lizenzierung",
                "typeRegular": "Regulär",
                "typeAudioMasteringServices": "Audio Mastering - Dienstleistungen",
                "typeVinylEarnings": "Vinyl-Einnahmen",
                "typeOffset": "Offset",
                "typeNotKnown": "Unbekannt",
                "quarterQ1": "Q1",
                "quarterQ2": "Q2",
                "quarterQ3": "Q3",
                "quarterQ4": "Q4",
                "monthJanuary": "Januar",
                "monthFebruary": "Februar",
                "monthMarch": "März",
                "monthApril": "April",
                "monthMay": "Mai",
                "monthJune": "Juni",
                "monthJuly": "Juli",
                "monthAugust": "August",
                "monthSeptember": "September",
                "monthOctober": "Oktober",
                "monthNovember": "November",
                "monthDecember": "Dezember"
            },
            "message": {
                "statementUnavailable": "Alle Abrechnungen, die vor Januar 2023 ausgestellt wurden, wurden per E-Mail an Ihren Account-Manager gesendet."
            }
        }
    }
};

export default subuserStatementsDE;